<template>

<div class="demo-title">  
  <h2>
    <slot name="title" />
  </h2>
  <p>
    <slot name="copy" />
  </p>
</div>

</template>

<style lang="scss" scoped>

.demo-title {
  margin: 0 0 50px;
  @media screen and (max-width: 940px) {
    margin: 0 0 30px;
  }
}
.demo-title h2 {
  color: var(--gray-900);
  font-weight: 700;
  font-size: var(--typ-h4);
  line-height: 1.3575;
  margin: 0 auto 10px;
  text-align: center;
  @media screen and (max-width: 940px) {
    font-size: var(--typ-h7);
    margin: 0 auto 4px;
  }
}

.demo-title p {
  color: var(--gray-700);
  font-size: var(--type-body3);
  line-height: 1.45;
  margin: 0 auto;
  text-align: center;
  @media screen and (max-width: 940px) {
    font-size: var(--typ-body5);
  }
}

</style>